<template>
<div>
    <h1 class="subtitle">Caja Chica</h1>
    <div class="nj-card">
        <div>
            <div class="nj-cols form c4">
                <b-field label="Código" custom-class="is-small">
                    <b-input v-model="caja.caj_codigo" size="is-small"></b-input>
                </b-field>
                <b-field label="Estado" custom-class="is-small">
                    <b-autocomplete icon="magnify" clearable size="is-small" :open-on-focus="true" field="est_descripcion" :data="caja_estados" v-model="estado_text" @select="setEstado">
                        <template slot="empty">No results found</template>
                        <template slot-scope="props">{{ props.option.est_descripcion }}</template>
                    </b-autocomplete>
                </b-field>
                <b-field label="Centro de Costo" custom-class="is-small">
                    <b-autocomplete icon="magnify" clearable size="is-small" :open-on-focus="true" field="cec_descripcion" :data="centros_costo_filtered" v-model="cec_descripcion_text"
                        @select="setCentroCosto">
                        <template slot="empty">No results found</template>
                        <template slot-scope="props">{{ props.option.cec_codigo }} {{ props.option.cec_descripcion }}</template>
                    </b-autocomplete>
                </b-field>
                <b-field label="Fecha inicio" custom-class="is-small">
                    <b-datepicker v-model="caj_fecha_inicio" :show-week-number="showWeekNumber" :locale="locale" icon="calendar-today" size="is-small" :day-names="dias" :month-names="meses">
                        <b-button label="Borrar" type="is-danger" icon-left="close" size="is-small" outlined @click="caj_fecha_inicio = null" />
                    </b-datepicker>
                </b-field>
                <b-field label="Fecha fin" custom-class="is-small">
                    <b-datepicker v-model="caj_fecha_fin" :show-week-number="showWeekNumber" :locale="locale" icon="calendar-today" size="is-small" :day-names="dias" :month-names="meses">
                        <b-button label="Borrar" type="is-danger" icon-left="close" size="is-small" outlined @click="caj_fecha_fin = null" />
                    </b-datepicker>
                </b-field>
                <b-field label="Tipo Caja" custom-class="is-small">
                    <b-autocomplete icon="magnify" clearable size="is-small" :open-on-focus="true" field="tca_descripcion" :data="tipo_caja_filtered" v-model="tca_descripcion_text"
                        @select="setTipoCaja">
                        <template slot="empty">No results found</template>
                        <template slot-scope="props">
                            {{ props.option.tca_descripcion }}
                        </template>
                    </b-autocomplete>
                </b-field>
                <b-field label="Titulo" custom-class="is-small">
                    <b-input v-model="caja.caj_titulo" size="is-small"></b-input>
                </b-field>
            </div>
            <Buttons line>
                <Button @click="buscar" icon="find" label="Buscar"></Button>
                <Button @click="nuevo()" label="Nueva solicitud caja"></Button>
                <Button @click="generarReporteCaja" icon="excel" label="Reporte cajas"></Button>
                <Button @click="generarReporteRendicion" icon="excel" label="Reporte rendiciones"></Button>
            </Buttons>
        </div>
    </div>
    <div class="nj-card">
        <b-table :data="cajas" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition"
            :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" aria-next-label="Next page"
            aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
            <template slot-scope="props">
                <b-table-column label="Codigo" header-class="is-info">{{ props.row.caj_codigo }}</b-table-column>
                <b-table-column label="Tipo" header-class="is-info">{{ props.row.tca_descripcion }}</b-table-column>
                <b-table-column label="Centro costo" header-class="is-info">{{ props.row.cec_descripcion }}</b-table-column>
                <b-table-column label="Titulo" header-class="is-info">{{ props.row.caj_titulo }}</b-table-column>
                <b-table-column label="Monto" header-class="is-info">
                    <div style="text-align: right;">{{ props.row.caj_monto_text }}</div>
                </b-table-column>
                <b-table-column label="Solicitante" header-class="is-info">{{ props.row.usu_nombre_solicitante }}</b-table-column>
                <b-table-column label="Estado" header-class="is-info">
                    <b-field>
                        <b-tag :class="setColorTag(props.row.est_id)">{{ props.row.est_descripcion }}</b-tag>
                    </b-field>
                </b-table-column>
                <b-table-column label="Fecha registro" header-class="is-info">{{ props.row.caj_fecha_registro }}</b-table-column>
                <b-table-column label="Opciones" header-class="is-info">
                    <div class="nj-flx">
                        <Button @click="redirect('/caja/view/' + props.row.caj_id)" type="icon" title="Ver Caja" icon="info"></Button>
                        <Button @click="redirect('/caja/view/' + props.row.caj_id)" type="icon" title="Solicitar Aprobacion Caja" icon="email" color="green"></Button>
                        <Button @click="redirect('/caja/view/' + props.row.caj_id)" type="icon" title="Solicitar Aprobacion Rendicion" icon="email" color="blue"></Button>
                        <Button @click="redirect('/caja/edit/' + props.row.caj_id)" type="icon" title="Editar Caja" icon="edit"></Button>
                        <Button @click="cancelar(props.row)" title="Cancelar" type="icon" icon="cancel" color="red"></Button>
                        <!-- <button class="nj-button --icon --blue" @click="redirect('/caja/view/' + props.row.caj_id)" title="Información"><i class="mdi mdi-information"></i></button> -->
                        <!-- <button class="nj-button --icon --green" @click="solicitarAprobacionCaja(props.row)" v-if="props.row.caj_opciones.solicitar_aprobacion_caja" title="Solicitar Aprobacion Caja"><i class="mdi mdi-email"></i></button> -->
                        <!-- <button class="nj-button --icon --green" @click="solicitarAprobacionRendicion(props.row)" v-if="props.row.caj_opciones.solicitar_aprobacion_rendicion" title="Solicitar Aprobacion Rendicion"><i class="mdi mdi-email"></i></button> -->
                        <!-- <button class="nj-button --icon" @click="redirect('/caja/edit/' + props.row.caj_id)" v-if="props.row.caj_opciones.editar_caja" title="Editar Caja"><i class="mdi mdi-circle-edit-outline"></i></button> -->
                        <!-- <button class="nj-button --icon --red" @click="cancelar(props.row)" v-if="props.row.caj_opciones.cancelar_caja" title="Cancelar"><i class="mdi mdi-cancel"></i></button> -->
                    </div>
                </b-table-column>
            </template>
        </b-table>
    </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import { getColorTag } from "../../constants"
import { AppService, CajaService, RendicionService, ResponseStatus, UsuarioService } from "../../rest"
import { calendar, DateTime, ExportarExcel, Toast } from "../../util"
import Confirm from "../../util/confirm"
import { Button, Buttons } from "../components"

export default {
    name: "Caja",
    components: {
        Buttons,
        Button,
    },
    data() {
        return {
            showWeekNumber: false,
            locale: "es-ES",
            dias: calendar.days,
            meses: calendar.months,
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
            gerentes: [],
            usuarios: [],
            tipos_documento: [],
            centros_costo: [],
            tipos_caja: [],
            caja_estados: [],
            monedas: [],
            cajas: [],
            cec_descripcion_text: "",
            tca_descripcion_text: "",
            estado_text: "",
            caj_fecha_inicio: new Date(),
            caj_fecha_fin: new Date(),
            caja: {
                cec_id: null,
                tca_id: null,
                est_id: null,
                caj_fecha_registro: null,
                caj_descripcion: null,
                caj_fecha_inicio: new Date(),
                caj_fecha_fin: new Date(),
            },
        }
    },
    computed: {
        ...mapGetters("AppStore", [
            "_message",
        ]),
        centros_costo_filtered() {
            return this.centros_costo
                ? this.centros_costo.filter((item) => {
                    let text1 = (item.cec_codigo + item.cec_descripcion).replace(/[\s.]/g, "").toLowerCase()
                    let text2 = this.cec_descripcion_text.replace(/[\s.]/g, "").toLowerCase()
                    return text1.indexOf(text2) >= 0
                })
                : []
        },
        tipo_caja_filtered() {
            return this.tipos_caja
                ? this.tipos_caja.filter((item) => {
                    let text1 = item.tca_descripcion.toLowerCase().replace(/[\s.]/g, "")
                    let text2 = this.tca_descripcion_text.toLowerCase().replace(/[\s.]/g, "")
                    return text1.indexOf(text2) >= 0
                })
                : []
        },
    },
    methods: {
        ...mapActions("AppStore", [
            "_setMessage",
            "_clearMessage",
            "_loadingOn",
            "_loadingOff",
        ]),
        nuevo() {
            this.$router.push("/caja/new")
        },
        reset() {
            this.selected = null
        },
        setCentroCosto(option) {
            this.caja.cec_id = option ? option.cec_id : null
        },
        setTipoCaja(option) {
            this.caja.tca_id = option ? option.tca_id : null
        },
        setEstado(option) {
            this.caja.est_id = option ? option.est_id : null
        },
        buscar() {
            this.caja.caj_fecha_inicio = calendar.format(this.caj_fecha_inicio, "date")
            this.caja.caj_fecha_fin = calendar.format(this.caj_fecha_fin, "date")
            CajaService
                .buscar(this.caja, UsuarioService.getUsuario())
                .then(
                    response => {
                        this.cajas = response.data
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error`, error)
                    }
                )
        },
        generarReporteCaja() {
            const request = {
                caja: this.caja
            }
            CajaService
                .generarReporteCaja(request)
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        ExportarExcel.generar(response.data, "reporte_caja")
                    }
                    else {
                        Toast.warn(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)

                })
        },
        generarReporteRendicion() {
            RendicionService
                .generarReporteRendicion(this.caja)
                .then(
                    response => {
                        ExportarExcel.generar(response.data, "reporte_rendicion_detalle")
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
        },
        setColorTag(est_id) {
            return getColorTag(est_id)
        },
        solicitarAprobacionCaja(caja) {
            CajaService
                .solicitarAprobacionCaja({
                    caj_id: caja.caj_id
                }).then(
                    response => {
                        Toast.success(response.message)
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error`, error)
                    }
                )
        },
        solicitarAprobacionRendicion(caja) {
            RendicionService
                .solicitarAprobacionRendicion({
                    caj_id: caja.caj_id
                }).then(
                    response => {
                        Toast.success(response.message)
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error`, error)
                    }
                )
        },
        cancelar(caja) {
            Confirm.show({
                message: "¿Esta seguro de cancelar la caja?",
                action: () => {
                    CajaService
                        .cancelar({
                            caj_id: caja.caj_id
                        }).then(
                            response => {
                                Toast.success(response.message)
                                this.buscar()
                            },
                            error => {
                                Toast.error(error)
                                console.error(`error`, error)
                            }
                        )
                }
            })
        },
        redirect(url) {
            this.$router.push(url)
        },
    },
    mounted() {
        if (this._message) {
            Toast.success(this._message)
            setTimeout(() => {
                this._clearMessage()
            }, 4000)
        }
        this.caj_fecha_inicio = DateTime.getDate({ days: -7 })
        this.caj_fecha_fin = DateTime.getDate()
        AppService
            .getData(["caja_estados", "centros_costo", "gerentes", "usuarios", "tipos_caja", "monedas", "tipos_documento"])
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.caja_estados = response.data.caja_estados
                    this.centros_costo = response.data.centros_costo
                    this.tipos_caja = response.data.tipos_caja
                    this.monedas = response.data.monedas
                    this.gerentes = response.data.gerentes
                    this.usuarios = response.data.usuarios
                    this.tipos_documento = response.data.tipos_documento
                    this.buscar()
                }
                else {
                    Toast.warn(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    }
}
</script>
<style scoped></style>